import {NumberFormatValues} from 'react-number-format';
import InputNumber from './InputNumber';

interface Props {
    onChange: (value: any) => void;
    onBlur?: (value: any) => void;
    value: number | string;
    className?: string;
    isAllowed?: (values: NumberFormatValues) => any;
    thousandSeparator?: boolean;
    allowLeadingZeros?: boolean;
    allowNegative?: boolean;
    disabled?: boolean;
}

/**
 * Controlled-component 방식 number input
 * @param value - 기본값
 * @param onChange - onChange Handler
 * @param onBlur - onBlur Handler
 * @param className - 추가 className
 * @param isAllowed - 허용 validation
 * @param thousandSeparator - 천단위 콤마
 * @param allowLeadingZeros - 첫글자 0 허용
 * @param allowNegative - 음수 허용
 * @param disabled - disabled
 */
export default function InputNumberC({
                                         value,
                                         onChange,
                                         onBlur,
                                         className = '',
                                         isAllowed,
                                         thousandSeparator = true,
                                         allowLeadingZeros = false,
                                         allowNegative = true,
                                         disabled,
                                     }: Props) {
    return (
        <InputNumber
            defaultValue={value}
            onValueChange={(values) => {
                onChange && onChange(values.floatValue);
            }}
            className={`form-control text-end ${className}`}
            isAllowed={isAllowed}
            thousandSeparator={thousandSeparator}
            allowLeadingZeros={allowLeadingZeros}
            allowNegative={allowNegative}
            displayType={'input'}
            disabled={disabled}
            onBlur={onBlur}
        />
    );
}
